module.exports = __webpack_public_path__ + "static/media/3.60f0c466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/images/3.svg
// module id = 226
// module chunks = 0